import { DataBean } from "../../DataBean";


export class TechnologyTypeConstants extends DataBean {


    public async getHealthTechnologyTypeConstants(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthTechnologyTypeConstants_Number", [args]);
    }


}